import React, {FC, useState, useEffect} from "react"
import qs from "qs"

import {useGetSignUpQuery} from "@irati/signup/hooks"

import {SignUpStage} from "@irati/types"
import History from "@irati/utils/history"
import PageNotFound from "../../components/SignUp/Cards/PageNotFound"
import ProgressBar from "../../components/SignUp/ProgressBar"
import Footer from "../../components/SignUp/Footer"
import Header from "../../components/SignUp/Header"
import {SignUpWrapper} from "../../components/SignUp/styled"
import ReviewingYourDetails from "../../components/SignUp/Cards/ReviewingYourDetails"
import ConfirmPackage from "./ConfirmPackage"
import KnowYourBusiness from "./KnowYourBusiness"
import KnowYourCustomer from "./KnowYourCustomer"
import Payment from "./Payment"
import Welcome from "./Welcome"

export enum SelfSignUpScreens {
  WelcomeScreen = "Welcome",
  ConfirmPackageScreen = "ConfirmPackage",
  KnowYourBusinessScreen = "KnowYourBusiness",
  KnowYourCustomerScreen = "KnowYourCustomer",
  PaymentScreen = "Payment",
  PaymentSuccess = "PaymentSuccess"
}

const SelfSignUp: FC = () => {
  const [screen, setScreen] = useState(SelfSignUpScreens.ConfirmPackageScreen)
  const [progressScreen, setProgressScreen] = useState(SelfSignUpScreens.ConfirmPackageScreen)
  const [isInitialLoad, setInitialLoad] = useState(true)
  const [error, setError] = useState(false)
  const query = qs.parse(window.location.search.replace("?", ""))
  const signUp = useGetSignUpQuery({uuid: query.uuid}, {fetchPolicy: "cache-and-network"})

  useEffect(() => {
    if (signUp?.data) {
      setError(false)
      if (isInitialLoad) {
        setInitialLoad(false)
        const stage = signUp?.data?.stage

        if (stage) {
          if (stage === SignUpStage.SignUpStageIndividual) {
            setScreen(SelfSignUpScreens.KnowYourCustomerScreen)
            setProgressScreen(SelfSignUpScreens.KnowYourCustomerScreen)
          } else if (stage === SignUpStage.SignUpStageCompany) {
            setScreen(SelfSignUpScreens.KnowYourBusinessScreen)
            setProgressScreen(SelfSignUpScreens.KnowYourBusinessScreen)
          } else if (stage === SignUpStage.SignUpStageDetailsAndPackage) {
            setScreen(SelfSignUpScreens.ConfirmPackageScreen)
            setProgressScreen(SelfSignUpScreens.ConfirmPackageScreen)
          } else {
            setScreen(SelfSignUpScreens.PaymentScreen)
            setProgressScreen(SelfSignUpScreens.PaymentScreen)
          }
        }
      }
    }
  }, [signUp?.data])

  useEffect(() => {
    if (signUp?.error) {
      setError(true)
    }
  }, [signUp?.error])

  const handleConfirmPackageSuccess = () => {
    setScreen(SelfSignUpScreens.KnowYourBusinessScreen)
    setProgressScreen(SelfSignUpScreens.KnowYourBusinessScreen)
  }

  const handleKYBSuccess = () => {
    setScreen(SelfSignUpScreens.KnowYourCustomerScreen)
    setProgressScreen(SelfSignUpScreens.KnowYourCustomerScreen)
  }

  const handleKYCSuccess = () => {
    setScreen(SelfSignUpScreens.PaymentScreen)
    setProgressScreen(SelfSignUpScreens.PaymentScreen)
  }

  const handleEditPlan = () => {
    setScreen(SelfSignUpScreens.ConfirmPackageScreen)
  }

  const onStartSetup = () => {
    History.replace({pathname: `/signup?uuid=${signUp.data.uuid}`})
  }

  if (screen === SelfSignUpScreens.ConfirmPackageScreen && query?.page) {
    return (
      <SignUpWrapper>
        <Header />
        {error && !signUp?.data ? (
          <PageNotFound />
        ) : signUp?.loading ? (
          <ReviewingYourDetails />
        ) : (
          <Welcome user={signUp?.data?.enquiry} onClick={onStartSetup} signUp={signUp} />
        )}
      </SignUpWrapper>
    )
  }

  return (
    <SignUpWrapper>
      <Header screen={screen} error={error && !signUp?.data} />
      {signUp?.data && (
        <>
          <ProgressBar screen={progressScreen} updateScreen={setScreen} />
          {screen === SelfSignUpScreens.ConfirmPackageScreen && (
            <ConfirmPackage signUp={signUp} onConfirmedPackage={handleConfirmPackageSuccess} />
          )}
          {screen === SelfSignUpScreens.KnowYourBusinessScreen && <KnowYourBusiness signUp={signUp} onKYBCompleted={handleKYBSuccess} />}
          {screen === SelfSignUpScreens.KnowYourCustomerScreen && <KnowYourCustomer signUp={signUp} onKYCCompleted={handleKYCSuccess} />}
          {screen === SelfSignUpScreens.PaymentScreen && <Payment signUp={signUp} onEditPlan={handleEditPlan} />}
        </>
      )}
      {error && !signUp?.data && <PageNotFound />}
      <Footer />
    </SignUpWrapper>
  )
}

export default SelfSignUp
